import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import {
	GenerateTemplateRequest,
	GetTemplatesRequest,
	GenerateCellInfoRequest
} from '../requests/TechAddRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_TEMPLATES = 'GET_TEMPLATES';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetTemplates = (value) => ({
	type: GET_TEMPLATES,
	templates: value
});

export const ProcessFile = (fileLocation, userId, template) => async (dispatch) => {
	await GenerateTemplateRequest(fileLocation, userId, template).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateTemplate = (file, userId, template) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessFile(response.data, userId, template));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetTemplates = () => async (dispatch) => {
	await GetTemplatesRequest().then(response => {
		dispatch(onGetTemplates(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ProcessFileCellInfo = (fileLocation, userId) => async (dispatch) => {
	await GenerateCellInfoRequest(fileLocation, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateCellInfo = (file, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessFileCellInfo(response.data, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
